const getStrapiConfig = () => {
  const strapiUrl = process.env.REACT_APP_STRAPI_URL;
  const strapiToken = process.env.REACT_APP_STRAPI_API_TOKEN;

  if (!strapiUrl) {
    throw new Error(
      'Strapi URL is not configured. Please set REACT_APP_STRAPI_URL in your environment variables.'
    );
  }

  if (!strapiToken) {
    throw new Error(
      'Strapi API token is not configured. Please set REACT_APP_STRAPI_API_TOKEN in your environment variables.'
    );
  }

  return { strapiUrl, strapiToken };
};

/**
 * 
 * @param {string} path 
 * @param {Object} options
 */
export const strapiFetch = async (path, options = {}) => {
  const { strapiUrl } = getStrapiConfig();

  const {
    method = 'GET',
    body = undefined,
    headers: extraHeaders = {},
  } = options;

  const headers = {
    'Content-Type': 'application/json',
    ...extraHeaders,
  };

  const fetchOptions = {
    method,
    headers,
  };

  if (body !== undefined) {
    fetchOptions.body = typeof body === 'string' ? body : JSON.stringify(body);
  }

  try {
    const response = await fetch(`${strapiUrl}${path}`, fetchOptions);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const errorMessage =
        errorData?.error?.message ||
        `Strapi request failed with status ${response.status}`;

      const httpError = new Error(errorMessage);
      httpError.status = response.status;
      throw httpError;
    }

    return await response.json();
  } catch (error) {
    if (error.status) throw error;
    if (error.name === 'TypeError' || error.message.includes('fetch')) {
      throw new Error(
        'Unable to reach the server. Please check your internet connection and try again.'
      );
    }
    throw error;
  }
};